// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IntakeSimpleIntakeDefaultResponse {
    static getAttributeTypeMap() {
        return IntakeSimpleIntakeDefaultResponse.attributeTypeMap;
    }
}
IntakeSimpleIntakeDefaultResponse.discriminator = undefined;
IntakeSimpleIntakeDefaultResponse.additionalProperties = false;
IntakeSimpleIntakeDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "SimpleIntakeResponseModel"
    },
];
//# sourceMappingURL=intakeSimpleIntakeDefaultResponse.js.map